export default __webpack_public_path__ + "alberta-shoppingcart.88c42375a21813130d2f.svg";